<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card p-5" v-if="general">
        <!-- encabezado -->
        <div class="row"> 
          <div class="col-md-6">
            <div class="row d-flex justify-content-start">
              <div class="col-md-6" >
                <Input
                  :type="'text'"
                  :inputClass="'form-control inputInicial'"
                  :idInput="'agente'"
                  :forLabel="'agente'"
                  :label="'Agente'"
                  :placeholder="'Nombre del Agente'"
                  :disabled="true"
                  :required="false"
                  :value="agenteGeneral"
                  style="font-weight: bold;"
                />
              </div>
              <div class="col-md-3">
                <Input
                  :type="'text'"
                  :inputClass="'form-control inputInicial'"
                  :idInput="'clave'"
                  :forLabel="'clave'"
                  :label="'Clave'"
                  :placeholder="'Clave'"
                  :disabled="true"
                  :required="false"
                  :value="claveAgenteGeneral"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row d-flex justify-content-end">
              <div class="col-md-4">
                <Input
                  :type="'text'"
                  :inputClass="'form-control inputInicial'"
                  :idInput="'cliente'"
                  :forLabel="'cliente'"
                  :label="'Cliente'"
                  :placeholder="'Nombre del Cliente'"
                  :disabled="true"
                  :required="false"
                  :value="idClienteUnico"
                />
              </div>
              <div class="col-md-4">
                <Input
                  :type="'text'"
                  :inputClass="'form-control inputInicial'"
                  :idInput="'cotizacion'"
                  :forLabel="'cotizacion'"
                  :label="'Cotización'"
                  :placeholder="'Cotización'"
                  :disabled="true"
                  :required="false"
                  :value="numCotizacion"
                />
              </div>
              <!-- <div class="col-md-3">
                <Input
                  :type="'number'"
                  :inputClass="'form-control'"
                  :idInput="'poliza'"
                  :forLabel="'poliza'"
                  :label="'Póliza/Renovación'"
                  :placeholder="'Renovación'"
                  :required="true"
                />
              </div> -->
              <div class="col-md-4">
                <Input
                  :type="'text'"
                  :inputClass="'form-control inputInicial'"
                  :idInput="'poliza'"
                  :forLabel="'poliza'"
                  :label="'Fecha cotización'"
                  :placeholder="'Renovación'"
                  :required="true"
                  disabled
                  :value="fechaCotizacion"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12">
            <hr />
          </div>
        </div>
        <!-- datos generales -->
        <div class="row">
          <div class="col-md-12">
            <h3 class="title">Datos Generales</h3>
            <p style="font-size: medium; color: rgb(0, 0, 0);">
              Ingresa la forma de pago, vigencia y fecha de inicio (fin de
              vigencia de acuerdo a las fechas del calendario de la SEP).
            </p>
          </div>
        </div>

        <form @submit.prevent="cotizarGuardar" class="row g-3 needs-validation" novalidate>
          <div class="row">
            <div class="col-md-3">
              <label for="" class="form-label">Forma de pago</label>
              <select id="formaPago" :class="['form-control', {'is-invalid': isInvalid.FP }]"  v-model="formaDePago" name="pago" required="true" :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'">
                  <option  selected disabled>Selecciona opción</option>
                  <option v-for="(item, i) in catFP" :value="item.ID_FORMA_PAGO" :key="i"> {{ item.NOM_FORMA_PAGO }}</option>
              </select>
              <div class="invalid-feedback">
                Campo obligatorio.
              </div>
            </div>
            <div class="col-md-5">
              <label for="" class="form-label">Vigencia (Ciclo escolar/Ciclo escolar + Verano)</label>
              <select id="selectvigencia" :class="['form-control', {'is-invalid': isInvalid.vigencia }]" v-model="vigencia" :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
               required @change="sumasAseguradasFactor" >
                  <option :disabled="item.pValor == '0'" v-for="(item, i) in catVigencia" :value="item.pTexto" :key="i">
                    {{ item.pTexto }}
                    </option>
              </select>
              <div class="invalid-feedback">
                Campo obligatorio.
              </div>
            </div>
            <div class="col-md-2">
              <label for="" class="form-label">Inicio de vigencia</label>
              <input type="date" @change="finVigenciaM" v-model="inicioVigencia" id="inicioVigencia" :class="['form-control', {'is-invalid': isInvalid.inicioV }]" 
              :disabled="disabledAll || infoCotiz.B_MASIVO == 'V' || calculaInicio"
              >
               
              <div class="invalid-feedback">
                Campo obligatorio.
              </div>
            </div>
            <div class="col-md-2">
              <label for="" class="form-label">Fin de vigencia</label>

              <input type="text" class="form-control" placeholder="dd/mm/aaaa" id="finVigenciaInput" :value="finVigenciaInput" required="true" :disabled="disabledAll">
            </div>
          </div>
          <!-- colegio o institucion -->
          <div class="row">
            <div class="col-md-12 mt-4">
              <h3 class="title">Datos del Colegio o Institución</h3>
              <p style="font-size: medium; color: rgb(0, 0, 0);">
                Por favor revisa que toda la <b>información sea correcta</b>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="" class="form-label">Nombre del Colegio o Institución</label>
              <input type="text" :class="['form-control', {'is-invalid': isInvalid.colegio }]" required="true" v-model="colegio" ref="colegioI" :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"/>
              <div class="invalid-feedback">
                Campo obligatorio.
              </div>
            </div>
          </div>
          <!-- Personas a asegurar -->
          <div class="row">
            <div class="col-md-12 mt-4">
              <h3 class="title">Personas a asegurar</h3>
              <p style="font-size: medium; color: rgb(0, 0, 0);">
                Selecciona y llena los campos para cotizar
              </p>
            </div>
          </div>
          <div class="row">
            <!-- nivel escolar -->
            <div class="col-md-2">
              <h5 class="title2">Nivel Escolar</h5>
              <div class="round mb-2">
                <input
                  :id="`checkbox1`"
                  type="checkbox"
                  name="active1"
                  class="ml-2"
                  value="MATERNAL"
                  v-model="maternal"
                  :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
                />
                <label
                  :for="`checkbox1`"
                  class="label-checkbox"
                ></label>
                <label class="label-text ml-3 mt-1">Maternal</label>
              </div>
              <div class="round mb-2">
                <input
                  :id="`checkbox2`"
                  type="checkbox"
                  name="active2"
                  class="ml-2"
                  value="KINDER"
                  v-model="kinder"
                  :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
                />
                <label
                  :for="`checkbox2`"
                  class="label-checkbox"
                ></label>
                <label class="label-text ml-3 mt-1">Kinder</label>
              </div>
              <div class="round mb-2">
                <input
                  :id="`checkbox3`"
                  type="checkbox"
                  name="active3"
                  class="ml-2"
                  v-model="primaria"
                  :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
                />
                <label
                  :for="`checkbox3`"
                  class="label-checkbox"
                ></label>
                <label class="label-text ml-3 mt-1">Primaria</label>
              </div>
              <div class="round mb-2">
                <input
                  :id="`checkbox4`"
                  type="checkbox"
                  name="active4"
                  class="ml-2"
                  value="SECUNDARIA"
                  v-model="secundaria"
                  :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
                />
                <label
                  :for="`checkbox4`"
                  class="label-checkbox"
                ></label>
                <label class="label-text ml-3 mt-1">Secundaria</label>
              </div>
              <div class="round mb-2">
                <input
                  :id="`checkbox5`"
                  type="checkbox"
                  name="active2"
                  class="ml-2"
                  value="PREPARATORIA"
                  v-model="preparatpria"
                  :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
                />
                <label
                  :for="`checkbox5`"
                  class="label-checkbox"
                ></label>
                <label class="label-text ml-3 mt-1">Preparatoria</label>
              </div>
              <div class="round mb-5">
                <input
                  :id="`checkbox6`"
                  type="checkbox"
                  name="active6"
                  class="ml-2"
                  value="LICENCIATURA"
                  v-model="licenciatura"
                  :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
                />
                <label
                  :for="`checkbox6`"
                  class="label-checkbox"
                ></label>
                <label class="label-text ml-3 mt-1">Licenciatura</label>
              </div>
            </div>
            <!-- personas -->
            <div class="col-md-3">
              <h5 class="title2">Personas</h5>
              <div class="round mb-2">
                <input
                  :id="`checkbox`"
                  type="checkbox"
                  name="active"
                  class="ml-2"
                  value="ALUMNOS"
                  v-model="listPersonas"
                  @change="changePersonas($event)"
                  :disabled="alumnos || disabledAll || infoCotiz.B_MASIVO == 'V'"
                />
                <label
                  :for="`checkbox`"
                  class="label-checkbox"
                ></label>
                <label class="label-text ml-3 mt-1">Alumnos</label>
              </div>
              <div class="round mb-2">
                <input
                  :id="`checkboxDocente`"
                  type="checkbox"
                  name="activeDocente"
                  class="ml-2" 
                  value="PERSONAL DOCENTE"
                  v-model="listPersonas"
                  @change="changePersonas($event)"
                  :disabled="docentes || disabledAll || infoCotiz.B_MASIVO == 'V'"
                />
                <label
                  :for="`checkboxDocente`"
                  class="label-checkbox"
                ></label>
                <label class="label-text ml-3 mt-1">Personal Docente</label>
              </div>
              <div class="round mb-2">
                <input
                  :id="`checkboxAdministrativo`" type="checkbox" name="activeAdministrativo" class="ml-2" value="PERSONAL ADMINISTRATIVO"
                  v-model="listPersonas" @change="changePersonas($event)" :disabled="administrativos || disabledAll || infoCotiz.B_MASIVO == 'V'" />
                <label
                  :for="`checkboxAdministrativo`"
                  class="label-checkbox"
                ></label>
                <label class="label-text ml-3">Personal Administrativo</label>
              </div>
            </div>
            <!-- horario -->
            <div class="col-md-4 col-sm-12">
              <h5 class="title2">Horario Escolar (Jornada amplia)</h5>
              <div class="">

                <table class="table table-borderless mr-4">
                  <tbody>
                    <tr>
                      <td>
                        <label class="form-label">Inicio:</label>
                        <input type="time" class="form-control" v-model="matutinoDe" @change="changetime($event)" :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"/>
                      </td>
                      <!-- <td style="width: 20px;">A</td> -->
                      <p style="margin-top: 2.5rem;">A</p>
                      <td class="">
                        <label class="form-label">Fin:</label>
                        <input type="time" class="form-control" v-model="matutinoA" @change="changetime($event)" :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"/>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div class="row">
                <div class="col-sm-12">
                  <div class="row mb-3">
                    <div class="col-sm-5 col-md-5">
                      <label class="form-label">Inicio:</label>
                      <input type="time" class="form-control" v-model="matutinoDe" @change="changetime($event)"/>
                    </div>
                    <div class="col-sm-1 col-md-1 mt-2">
                      <label class="form-label mt-4">A</label>
                    </div>
                    <div class="col-sm-5 col-md-5">
                      <label class="form-label">Fin:</label>
                      <input type="time" class="form-control" v-model="matutinoA" @change="changetime($event)"/>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
            <!-- matriculas -->
            <div class="col-md-3">
              <h5 class="title2">Asegurados (mínimo {{ numeroAsegurados }} asegurados)</h5>
              <div class="row">
                <div class="col-md-7">
                  <p style="margin-top: 8px;">De 45 días a 11 años</p>
                </div>
                <div class="col-md-5">
                  <input 
                    @keypress="validarInput"
                    type="number"
                    :class="['form-control', {'is-invalid': isInvalid.m1 }]"
                    placeholder="personas"
                    required="true"
                    v-model="matricula1"
                    :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"

                    />
                </div>
              </div>
              <div class="row">
                <div class="col-md-7">
                  <p style="margin-top: 8px;">De 12 a 60 años</p>
                </div>
                <div class="col-md-5">
                  <input
                    @keypress="validarInput"
                    type="number"
                    :class="['form-control', {'is-invalid': isInvalid.m2 }]"
                    placeholder="personas"
                    required="true"
                    v-model="matricula2"
                    :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
                    />
                </div>
              </div>
              <div class="row">
                <div class="col-md-7">
                  <p style="margin-top: 8px;">De 61 a 65 años</p>
                </div>
                <div class="col-md-5">
                  <input
                    @keypress="validarInput"
                    type="number"
                    :class="['form-control', {'is-invalid': isInvalid.m3 }]"
                    placeholder="personas"
                    required="true"
                    v-model="matricula3"
                    :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
                    />
                </div>
              </div>
              <div class="row">
                <div class="col-md-7">
                  <p style="margin-top: 8px;">De 66 a 69 años</p>
                </div>
                <div class="col-md-5">
                  <input
                    @keypress="validarInput"
                    type="number"
                    :class="['form-control', {'is-invalid': isInvalid.m4 }]"
                    placeholder="personas"
                    required="true"
                    min="0"
                    v-model="matricula4"
                    :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'"
                    />
                </div>
              </div>
              <!-- <small>*El mínimo de asegurados es de {{ numeroAsegurados }}</small> -->
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <hr />
            </div>
          </div>
          <!-- Coberturas y cotización -->
          <div class="row">
            <div class="col-md-12">
              <h3 class="title">Coberturas y cotización</h3>
              <p style="font-size: medium; color: rgb(0, 0, 0);">
                Edita los deducibles, suma asegurada y da clic en el botón 
                cotizar para obtener la prima total.
              </p>
            </div>
          </div>
          <div class="row text-center mb-5">
            <div class="col-md-2 text-center">
              <label class="form-label" style="font-size: small;">MUERTE <br>ACCIDENTAL</label>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-9">
                  <select requerid :class="['form-select', {'is-invalid': isInvalid.ma }]" style="color: #00b2e3; font-weight: bold" v-model="sumaMuerte" id="sumaMuerte"
                    @change="sumasAseguradasLimite" :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'">
                    <option selected disabled value="">Suma Asegurada</option>
                    <option :disabled="item.Id == '0'" v-for="(item, i) in sumaAseg" :value="item.SA_ASEGURADA" :key="i"> {{ item.SA_ASEGURADA }}</option>
                  </select>
                  <div class="invalid-feedback">
                    Campo obligatorio.
                  </div>
                </div>
                <div class="col-md-1"></div>
              </div>
            </div>
            <div class="col-md-2 text-center">
              <label class="form-label" style="font-size: small;">GASTOS <br> FUNERARIOS</label>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-9">
                  <select :disabled="idRol != '20159' || infoCotiz.B_MASIVO == 'V'" class="form-select" style="color: #00b2e3; font-weight: bold" v-model="sumaGastos" >
                    <option selected value="">{{ sumaMuerte == "" ? "Suma asegurada" : sumaMuerte}}</option>
                    <option v-for="(item, i) in sumaAseg" :value="item.SA_ASEGURADA" :key="i"> {{ item.SA_ASEGURADA }}</option>
                  </select>
                </div>
                <div class="col-md-1"></div>
              </div>
            </div>
            <div class="col-md-3 text-center">
              <div class="row">
                <label class="form-label" style="font-size: small;">PERDIDAS <br> ORGÁNICAS</label>
                <div class="col-md-6">
                  <select requerid style="color: #00b2e3; font-weight: bold" :class="['form-select', {'is-invalid': isInvalid.po }]" 
                   :disabled="PO_Disabled || disabledAll || infoCotiz.B_MASIVO == 'V'" v-model="sumaPerdidaTipo" id="sumaPerdidaTipo">
                    <option selected disabled value="">Escala</option>
                    <option :value="item.CveTIndemniza" v-for="(item, i) in indemniza" :key="i">{{ item.CveTIndemniza }}</option>
                  </select>
                  <div class="invalid-feedback">
                    Campo obligatorio.
                  </div>
                </div>
                <div class="col-md-6">
                  <select :disabled="idRol != '20159' || infoCotiz.B_MASIVO == 'V'" class="form-select" style="color: #00b2e3; font-weight: bold" v-model="sumaPerdida">
                    <option :value="sumaPerdida">{{ sumaPerdida == "" ? "Suma asegurada" : sumaPerdida}}</option>
                    <option v-for="(item, i) in sumaAseg" :value="item.SA_ASEGURADA" :key="i"> {{ item.SA_ASEGURADA }}</option>
                    <option value=""></option>
                  </select>
                  </div>
              </div>
            </div>
            <div class="col-md-5 text-center">
              <div class="row">
                <label class="form-label" style="font-size: small;">REEMBOLSO <br> GASTOS MÉDICOS</label>
                <div class="col-md-4">
                  <select requerid style="color: #00b2e3; font-weight: bold" :class="['form-select', {'is-invalid': isInvalid.gmp }]" v-model="sumaRembolsoPorcent" id="sumaRembolsoPorcent"
                  @change="porcentajeRembolso" :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'">
                    <option selected disabled value="">Porcentaje</option>
                    <option v-for="(item, i) in catPorcentaje" :value="item.CveTRiesgoPer" :key="i">{{item.CveTRiesgoPer}}</option>
                  </select>
                  <div class="invalid-feedback">
                    Campo obligatorio.
                  </div>
                </div>
                <div class="col-md-4">
                  <select :disabled="idRol != '20159' || infoCotiz.B_MASIVO == 'V'" :class="['form-select', {'is-invalid': isInvalid.gms }]" class="form-select" style="color: #00b2e3; font-weight: bold" v-model="sumaRembolso">
                    <option :value="sumaRembolso">{{ sumaRembolso == "" ? "Suma asegurada" : sumaRembolso}}</option>
                    <option v-for="(item, i) in sumaAseg" :value="item.SA_ASEGURADA" :key="i"> {{ item.SA_ASEGURADA }}</option>
                  </select>
                  <div class="invalid-feedback">
                    Campo obligatorio.
                  </div>
                  </div>
                  <div class="col-md-4">
                  <select :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'" :class="['form-select', {'is-invalid': isInvalid.dedu }]" style="color: #00b2e3; font-weight: bold" v-model="deducibleGastos" requerid>
                    <option selected disabled value="">Deducible</option>
                    <option v-for="(item, i) in catDeducible" :value="item.DEDUCIBLE" :key="i"> {{ item.DEDUCIBLE }}</option>
                  </select>
                  <div class="invalid-feedback">
                    Campo obligatorio.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h3 class="title">Sistema de administración</h3>
              <p style="font-size: medium; color: rgb(0, 0, 0);">
                Selecciona el sistema con el cual deseas administrar la póliza. Una vez realizada la emisión, 
                no podrá ser modificada durante la vigencia de la misma.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-check round">
                <input :disabled="infoCotiz.B_MASIVO == 'V'" class="form-check-input radio-margin" type="radio" value="N" name="flexRadioDefault" id="flexRadioDefault1" v-model="sistemaAdmon" @change="sisadmon">
                <label
                  :for="`flexRadioDefault1`"
                  class="label-radio"
                ></label>
                <label class="label-check-radio ml-3">
                  Normal
                </label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-check round">
                <input :disabled="infoCotiz.B_MASIVO == 'V'" class="form-check-input radio-margin" type="radio" value="SA" name="flexRadioDefault" id="flexRadioDefault2" v-model="sistemaAdmon" @change="sisadmon">
                <label
                  :for="`flexRadioDefault2`"
                  class="label-radio"
                ></label>
                <label class="label-check-radio ml-3">
                  Ajuste anual
                </label>
              </div>
            </div>
            
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <hr />
            </div>
          </div>
          <div class="row mt-4" style="line-height: 0%;">
            <div class=" col-sm-7 col-md-7"></div>
            <div class=" col-sm-3 col-md-3 totales">
              <p >PRIMA NETA</p>
              <p>PAGO FRACCIONADO</p>
              <p>GASTOS DE EXPEDICIÓN</p>
              <p>I.V.A.</p>
            </div>
            <div class="col-sm-2 col-md-2 float-right">
              <div class="montos">
                <p style="text-align: right">${{ primaNeta || "0.00" }} MXN</p>
                <p style="text-align: right">${{ pagoFR|| "0.00" }} MXN</p>
                <p style="text-align: right">${{ derechos || "0.00" }} MXN</p>
                <p style="text-align: right">${{ iva || "0.00" }} MXN</p>
              </div>
            </div>
          </div>
          <div class="">
            <div class="float-right mt-4" >
              <button type="submit" id="cotizarGuardar" class="btn btn-info " style="border-radius: 15px;" :disabled="disabledAll || infoCotiz.B_MASIVO == 'V'">
              Cotizar y guardar
              </button>
              <button type="submit" id="nuevaCotiz" v-if="actualizar" class="btn btn-primary ml-2" style="border-radius: 15px;" @click="reloadPage" >
                Nueva cotizacion
              </button>
            </div>
          </div>
        </form>

        <!--  -->
        <div v-if="cotizar">
          <div class="row mt-4">
            <div class="col-md-12">
              <hr />
            </div>
          </div>
          <div class="row mt-3">
            <div class="d-flex justify-content-between align-items-center">
              <p>Este importe incluye IVA y derechos de póliza</p>
              <h3 class="title">TOTAL: ${{ primaTotal }} MXN</h3>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <hr />
            </div>
          </div>
          <div class="row">
              <div class="">
                <button id="btnEmitir" type="button" class="btn btn-info border float-right" @click="emitir" 
                v-if="infoCotiz.B_MASIVO == 'V'" :disabled="infoCotiz.B_MASIVO == 'V'"
                >Emitir</button>
                <button id="btnCondiciones" type="button" class="btn btn-primary border mr-1 float-right" :disabled="infoCotiz.B_MASIVO == 'V'" @click="redirCondicionesEspe" v-if="infoCotiz.B_MASIVO == 'F' || condiciones "
                >Condiciones Especiales</button>
                <button id="btnAlta" type="button" class="btn btn-outline-primary border mr-1 float-right" :disabled="infoCotiz.B_MASIVO == 'V'"  @click="redirectCargaListado"
                >Alta de Asegurados</button>
                <button id="btnEnviar" :disabled="infoCotiz.B_MASIVO == 'V'" type="button" @click="modal.enviar = true" class="btn btn-outline-primary border mr-1 float-right"><i class="far fa-envelope mr-1"></i>Enviar</button>
                <button id="btnVerCotiz" :disabled="infoCotiz.B_MASIVO == 'V'" type="button" class="btn btn-outline-primary border mr-1 float-right" @click="getPDF"
                
                >Ver cotización</button>
              </div>
              
          </div>
        </div>
      </div>
      
      <!-- modal cotizacion -->
      <div>
          <CModal :show.sync="modal.cotizarGuardar" ref="my-modal" :close-on-backdrop="false">
              <template #header-wrapper >
                  <div class="text-center mb-3" >
                      <div class="row">
                        <div class="col-10"></div>
                        <div class="col-1 mt-2">
                          <button type="button" class="btn-close ml-4" aria-label="Close" @click="modalCotizar"></button>
                        </div>
                      </div>
                  </div>
              </template>
              <template #footer-wrapper><span></span></template>
              <div class="card-body text-center">
                <img src="img/Logotipo Aula Latino2.png" alt="" style="height: 130px;">
                  <h3 class="text-center mt-5" style="color:rgb(112, 107, 107); font-weight:bold">¡Tu cotización esta lista!</h3>
                  <h3 class="mt-4" style="color: deepskyblue; ">{{ numCotizacion }}</h3>
                  <p class="mt-4">Para revisar la prima total y continuar con el proceso de contratación o consulta, cierra este aviso.</p>
              </div>
              <!-- <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
                  <CButton @click="modal = false" color="secondary" class="mr-2">
                      OK
                  </CButton>
              </CCardFooter> -->
          </CModal>
      </div>

      <!-- modal enviar -->
      <div>
          <CModal :show.sync="modal.enviar" ref="my-modal" :close-on-backdrop="false">
              <template #header-wrapper >
                  <div class="text-center mb-3" >
                      <div class="row">
                        <div class="col-10"></div>
                        <div class="col-1 mt-2">
                          <button type="button" class="btn-close ml-4" aria-label="Close" @click="modal.enviar = false"></button>
                        </div>
                      </div>
                  </div>
              </template>
              <template #footer-wrapper><span></span></template>
              <div class="card-body text-center">
                <img src="img/Logotipo Aula Latino2.png" alt="" style="height: 130px;">
                  <h3 class="text-center mt-5" style="color:rgb(112, 107, 107); font-weight:bold">¡Tu cotización {{ numCotizacion }} sera enviada!</h3>
                  <div class="col-md-12">
                    <label class="form-label">Ingrese tu correo: </label>
                    <input type="email" class="form-control" placeholder="*correoregistrado@servidor.com.mx"  v-model="emailModal"/>
                  </div>
                  <CButton class="mt-4 border" color="info" @click="sendEmail">Enviar</CButton>
              </div>
          </CModal>
      </div>

       <!-- modal enviar Exito -->
      <div>
          <CModal :show.sync="modal.enviarExito" ref="my-modal" :close-on-backdrop="false">
              <template #header-wrapper >
                  <div class="text-center mb-3" >
                      <div class="row">
                        <div class="col-10"></div>
                        <div class="col-1 mt-2">
                          <button type="button" class="btn-close ml-4" aria-label="Close" @click="modal.enviarExito = false"></button>
                        </div>
                      </div>
                  </div>
              </template>
              <template #footer-wrapper><span></span></template>
              <div class="card-body text-center">
                <img src="img/cotizador_APE/Check.png" alt="" style="height: 90px;">
                  <h3 class="text-center mt-3" style="color:rgb(112, 107, 107); font-weight:bold">{{ titulo }}</h3>
                  <p class="mt-3">{{ texto  }}</p>
              </div>
          </CModal>
      </div>

      <!-- modal Ver cotizacion -->
      <div>
          <CModal size="lg" :show.sync="modal.verDoc" ref="my-modal" :close-on-backdrop="false">
              <template #header-wrapper >
                  <!-- <div class="header-modal p-2">
                    <div class="">
                      <CButton class="ml-3" @click="modal.verDoc = false" color="dark btn-modal float-right"><i class="fas fa-times"></i></CButton>
                      <CButton color="dark btn-modal float-right"><i class="fas fa-arrow-down fa-lg mr-1" @click="descargarDocumento"></i> Descargar</CButton>
                      <CButton color="dark btn-modal float-right"><i class="fal fa-print fa-lg mr-2"></i> Imprimir</CButton>
                    </div>
                  </div> -->
              </template>
              <template #footer-wrapper><span></span></template>
              <div class="card-body text-center">
                <iframe id="inlineFrameExample"
                  title="Inline Frame Example"
                  width="100%"
                  height="900"
                  :src="b64">
                </iframe>
              </div>
          </CModal>
      </div>
      <!-- modal datos faltantes -->
      <div>
        <CModal :show.sync="modal.faltantes" ref="my-modal" :close-on-backdrop="false">
              <template #header-wrapper >
                  <div class="text-center mb-3" >
                      <div class="row">
                        <div class="col-10"></div>
                        <div class="col-1 mt-2">
                          <button type="button" class="btn-close ml-4" aria-label="Close" @click="modal.faltantes = false"></button>
                        </div>
                      </div>
                  </div>
              </template>
              <template #footer-wrapper><span></span></template>
              <div class="card-body text-center">
                <img src="img/Logotipo Aula Latino2.png" alt="" style="height: 130px;">
                  <h4 class="text-center mt-5" style="color:rgb(112, 107, 107);"><b>Importante: </b> {{ errorM }}</h4>
              </div>
              <!-- <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
                  <CButton @click="modal = false" color="secondary" class="mr-2">
                      OK
                  </CButton>
              </CCardFooter> -->
          </CModal>
      </div>
    </div>
  </div>
</template>
<script>
import Input from "./tools/Input.vue"; 
import Select from "./tools/Select.vue";
import moment from 'moment';
import { create } from 'filepond';


export default {
  components: {
    Input,
    Select,

  },
  data() {
    return {
      modal:{
        cotizarGuardar: false,
        verCotizacion: false,
        enviar: false,
        enviarExito: false,
        verDoc: false,
        faltantes: false,
      },
      isInvalid: {
        FP : false,
        vigencia : false,
        inicioV : false,
        colegio : false,
        m1 : false,
        m2 : false,
        m3 : false,
        m4 : false,
        ma : false,
        po : false,
        gmp : false,
        gms : false,
        dedu : false,
      },
      cotizar: false,
      general: true,
      ifFaltantes: false,
      invalid: false,
      actualizar: false,
      alumnos: false,
      docentes: false,
      administrativos: false,
      ifhora: false,
      ifVigencia: false,
      condiciones: true,
      PO_Disabled: false,
      disabledAll: false,
      calculaInicio: false,
      limitePO: "",
      sistemaAdmon: "",
      idRol: localStorage.getItem('idRol'),
      factor: "",
      emailModal: "",
      msjEmail: "",
      numCotizacion: "",
      primaTotal: "",
      pIdCarga: "",
      Archivo: "",
      titulo: "",
      texto: "",
      convertPDF: "",
      redirect: "",
      vigencia: 0,
      inicioVigencia: "",
      finVigenciaInput: "",
      matricula1: "",
      matricula2: "",
      matricula3: "",
      matricula4: "",
      sumaMuerte: "",
      sumaGastos: "",
      sumaPerdida: "",
      sumaPerdidaTipo: "",
      sumaRembolso: "",
      sumaRembolsoPorcent: "",
      numeroAsegurados: "",
      deducibleGastos: "",
      formaDePago: 0,
      colegio: "",
      maternal: "",
      kinder: "",
      primaria: "",
      secundaria: "",
      preparatpria: "",
      licenciatura: "",
      matutinoDe: "",
      matutinoA: "",
      vespertinoDe: "",
      vespertinoA: "",
      b64: "",
      routeVersion: "",
      routeCot: "",
      agenteGeneral: "",
      claveAgenteGeneral: "",
      fechaCotizacion: "",
      primaNeta: "",
      pagoFR: "",
      iva: "",
      derechos: "",
      idClienteUnico: "",
      anual: "",
      normal: "",
      errorVigencia: "",
      errorM: "",
      listPersonas: [],
      catPorcentaje: [],
      listArchivo: [],
      catProducto: [],
      catlineas: [],
      catMonedas: [],
      catFP: [],
      catVigencia: [],
      catCoberturas: [],
      sumaAseg: [],
      catDeducible: [],
      listObjetos: [],
      arrVigencia: [],
      infoCotiz: [],
      arrCotiz: [],
      indemniza: [],
      cotizacionGenerada: {},
    }
  },
  methods: {
    sisadmon(){
      console.log(this.sistemaAdmon);
    },
    validarInput(event) {
      const charCode = event.which ? event.which : event.keyCode;
      // permite solo números (códigos de tecla entre 48 y 57 según el estándar ASCII)
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    async catIndemniza(){
      const payload = {
        metodo: "CATINDEMNIZAAPE",
        data: {
          peId_Tb_Factor: this.factor,
          peId_Rol: localStorage.getItem("idRol"),
          peId_Usuario_Logueado: localStorage.getItem("userId")
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const indemniza = await this.$store.getters.getRespuestaREST;
          this.indemniza = indemniza
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    async getObjetos(){
      const payload = {
        metodo: "GETOBJETOSXPAGEROLAPE",
        data: `Rol=${localStorage.getItem("idRol")}&Pagina=nuevo`,
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const objts = await this.$store.getters.getRespuestaREST;
          this.listObjetos = objts;
          this.listObjetos.map( obj => {
            if(obj.tipoobjeto === ''){
              const input = document.getElementById(obj.nombreobjeto);
              if (input) {
                input.parentNode.removeChild(input);
                input.disabled = true;
              } else {

              }
            }
            if (obj.tooltip === 'true') {
              const input = document.getElementById(obj.nombreobjeto);
              if (input) { input.disabled = true; }
            }
          })
        }
      } catch (error) {
        console.log(error);
      }
    },
    redirectCargaListado() {
      if(this.redirect == "nueva") {
        window.location.href = `/#/cotizador/escuelas/cargaListado?cot=${this.arrCotiz.pIdCotizacion}&version=${this.arrCotiz.pId_Version_Pol}&carga=${this.pIdCarga}`;
      } 
      else if(this.redirect == "edicion") {
        window.location.href = `/#/cotizador/escuelas/cargaListado?cot=${this.infoCotiz.ID_COTIZACION}&version=${this.infoCotiz.ID_VERSION_POL}&carga=${this.infoCotiz.ID_CARGA}`;
      }
    },
    modalFaltantes(mensaje){
      this.modal.faltantes = true;
      this.errorM = mensaje
    },
    cambia(){
      this.ifFaltantes = false;
      if(this.formaDePago == ""){
        this.isInvalid.FP = true
        this.ifFaltantes = true;
      }else {
        this.isInvalid.FP = false
      }
      if(this.vigencia == ""){
        this.isInvalid.vigencia = true
        this.ifFaltantes = true;

      }else {
        this.isInvalid.vigencia = false
      }
      if(this.inicioVigencia == ""){
        this.isInvalid.inicioV = true
        this.ifFaltantes = true;
      }else {
        this.isInvalid.inicioV = false
      }
      if(this.colegio == ""){
        this.isInvalid.colegio = true
        this.ifFaltantes = true;
      }else {
        this.isInvalid.colegio = false
      }
      if(this.sumaMuerte == ""){
        this.isInvalid.ma = true
        this.ifFaltantes = true;
      }else {
        this.isInvalid.ma = false
      }
      if (localStorage.getItem('idRol') != '20159') {
        if(this.limitePO != '0') {
          if(this.sumaPerdidaTipo == ""){
            this.isInvalid.po = true
            this.ifFaltantes = true;
          }else {
            this.isInvalid.po = false
          }
        }
      }
      if(this.sumaRembolsoPorcent == ""){
        this.isInvalid.gmp = true
        this.ifFaltantes = true;
      }else {
        this.isInvalid.gmp = false
      }
      if(this.sumaGastos == ""){
        this.isInvalid.gms = true
        this.ifFaltantes = true;
      }else {
        this.isInvalid.gms = false
      }
      if(this.deducibleGastos == ""){
        this.isInvalid.dedu = true
        this.ifFaltantes = true;
      }else {
        this.isInvalid.dedu = false
      }

    },
    changetime(e){
      if (this.matutinoDe != "" && this.matutinoA != "") {
        this.ifhora = true
      }
      if (this.vespertinoDe != "" && this.vespertinoA != "") {
        this.ifhora = true
      }
    },
    changePersonas(e){
    },
    reloadPage(){
      window.location.href = `${location.origin}/#/cotizador/escuelas/nuevo`;
      location.reload()
    },
    descargarDocumento(){
      this.convertPDF = 'data:text/csv;base64,' + b64;
      var down = document.createElement('a');
      down.href = this.convertExcel;
      down.target = '_blank';
      down.download = 'Layout'
      document.body.appendChild(down);
      down.click();
      document.body.removeChild(down)
    },
    //Metodo para visualizar el documento de cotización.
    modalVerCotizacion(){
      this.modal.verDoc = true;
    },
    modalExito(title, text){
      this.modal.enviarExito = true;
      this.modal.enviar = false;
      this.titulo = title
      this.texto = text
    },
    modalCotizar(){
      this.modal.cotizarGuardar = false;
      this.cotizar = true;
      this.getObjetos()
    },
    async catalogoPorcentajesRGM(){
      const payload = {
        metodo: "CATALOGORGMPORCENTAJEAPE",
        data: {
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pId_Lin_Negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
          Id_Tb_Factor: this.factor,
          pId_Agente: localStorage.getItem("userId") 
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const porcent = this.$store.getters.getRespuestaREST;
        this.catPorcentaje = porcent
      }
    },
    async catalogoProductos(){
      const payload = {
        metodo: "CATPRODUTOSAPE",
        data: {
          pId_Empresa: "8",
          pId_Agente: localStorage.getItem("userId") 
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const productos = this.$store.getters.getRespuestaREST;
        this.catProducto = productos[0];
      }
    },
    async catalogoLineas(){
      const payload = {
        metodo: "CATLINEASAPE",
        data: {
          pId_Empresa: "8",
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pId_Agente: localStorage.getItem("userId") 
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const lineas = this.$store.getters.getRespuestaREST;
        this.catlineas = lineas[0];
      }
    },
    async catalogoMoneda(){
      const payload = {
        metodo: "CATMONEDAAPE",
        data: {
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const monedas = this.$store.getters.getRespuestaREST;
        this.catMonedas = monedas[0];
      }
    },
    async catalogoVigencia(){
      var config = {
        metodo: "CATVIGENCIAAPE",
        data: "",
      };
      this.$store.dispatch("metodoPost", config).then(() => {
        const res = this.$store.getters.getRespuestaREST;
        this.catVigencia = res
      });
    },
    async catalogoFormaPago(){
      const payload = {
        metodo: "CATFORMAPAGOAPE",
        data: {
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pId_Moneda: this.catMonedas.ID_MONEDA.toString(),
          pId_Cond_Cobro: "15",
          pId_Lin_Negocio: this.catlineas.ID_LIN_NEGOCIO.toString()
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const fp = this.$store.getters.getRespuestaREST;
        this.catFP = fp;
      }
    },
    async finVigenciaM(){
      this.isInvalid.inicioV = false;
      let ini_Vigencia = moment(this.inicioVigencia).format('DD/MM/YYYY');
      const payload = {
        metodo: "FINVIGENCIAAPE",
        data: {
          pFechaInicio: ini_Vigencia,
          pVigenciaTexto: this.vigencia,
          pUsuarioRegistro: localStorage.getItem("userId"),
          peId_Rol: localStorage.getItem("idRol")
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const vigencia = this.$store.getters.getRespuestaREST;
          
            if(vigencia != ''){
              this.finVigenciaInput = vigencia;
            } else {
              this.finVigenciaInput = ''
            }
          // }
        } else {
          this.errorVigencia = this.$store.getters.getDataRaw.errorMessage
          this.$swal({
              icon: 'error',
              title: 'Error',
              text: error,
            });
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    async catSumaAsegurada(){
      if(this.formaDePago == '2' && this.vigencia == 'Ciclo Escolar'){
        this.vigencia = ""; 
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: "La forma de pago semestral solo aplica para cobertura Ciclo Escolar + Verano.",
        });
        return
      }
      const payload = {
        metodo: "SUMAASEGURADAAPE",
        data: {
          pId_Moneda: this.catMonedas.ID_MONEDA.toString(),
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pid_lin_negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
          pePlazoBasico: this.vigencia == "Ciclo Escolar" ? "10" : "12",
          peIdAgente: localStorage.getItem("userId"),
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const suma = this.$store.getters.getRespuestaREST;
          setTimeout(() => {
            if (this.infoCotiz.B_CE == 'V') {
              console.log('entra catSumaAsegurada');
              this.sumaAseg = suma
            } 
          }, 1500);
        }
      } catch (error) {
        console.log(error);
      }

      
    },
    async deducible(){
      const payloadDeducible = {
        metodo: "DEDUCIBLEAPE",
        data: {
          peId_Moneda: this.catMonedas.ID_MONEDA.toString(),
          peIdProducto: this.catProducto.ID_PRODUCTO.toString(),
          peIdVersion: this.catProducto.ID_VERSION.toString(),
          peId_Lin_Negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
          peId_Agente: localStorage.getItem("userId"),
          peId_Rol: localStorage.getItem("idRol"),
          peId_Tb_Factor: this.factor,
          peB_CE: this.infoCotiz.B_CE,
          peId_Rol: localStorage.getItem("idRol"),
        },
      };
      const resDeducible = await this.$store.dispatch("metodoPost", payloadDeducible);
      try {
        if (resDeducible) {
          const deducible = this.$store.getters.getRespuestaREST;
          this.catDeducible = deducible
          if (this.infoCotiz.B_CE == 'V') {
            let nuevoElemento = {
              "Id": "0",
              "DEDUCIBLE": "0"
            }
            // Agregar nuevoElemento al principio del array
            this.catDeducible.unshift(nuevoElemento);
          } 
        }
      } catch (error) {
        console.log(error);
      }
    },
    async catalogoCoberturas(){
      const payload = {
        metodo: "CATCOBERTURASAPE",
        data: {
          pId_Cotizacion: null,
          pId_Lin_Negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
          pId_Usuario: "WEB",
          pId_Moneda: this.catMonedas.ID_MONEDA.toString(),
          pId_Inciso: "1",
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pId_Paquete: null,
          pId_UsuarioLogueado: localStorage.getItem("userId"),
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const coberturas = this.$store.getters.getRespuestaREST;
          this.catCoberturas = coberturas;
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    //Grabar cotizacion
    async cotizarGuardar(){
      console.log(this.infoCotiz.CVE_SIST_ADMON);
      this.isInvalid.inicioV = false;
      this.invalid = false;
      //Validaciones 
      this.cambia()
      if(this.ifFaltantes == true){
        this.modalFaltantes('Completa todos los datos para realizar tu cotización.');
        return;
      }
      if(this.sistemaAdmon == ""){
        this.modalFaltantes('Debes seleccionar un Sistema de Administracion.');
        return;
      }
      if(this.maternal == "" && this.kinder == "" && this.primaria == "" && this.secundaria == "" && this.preparatpria == "" && this.licenciatura == ""){
        this.modalFaltantes('Debes seleccionar al menos un Nivel Escolar.');
        return;
      }
      if( this.listPersonas.length == []){
        this.modalFaltantes('Debes seleccionar al menos un tipo de personal.');
        return;
      }
      if(this.formaDePago == '2' && this.vigencia == 'Ciclo Escolar'){
        this.modalFaltantes('La forma de pago semestral solo aplica para cobertura Ciclo Escolar + Verano.');
        return
      }
      if(this.routeCot == undefined){
        if (this.ifhora == false) {
        this.modalFaltantes('El horario es invalido, seleciona AM/PM.');
        return
      }
      }
      let ini_Vigencia = moment(this.inicioVigencia).format('DD/MM/YYYY');
      const payload = {
        metodo: "GRABARCOTIZACIONAPE",
        data: {
            peID_COTIZACION: this.cotizacionGenerada.pIdCotizacion == undefined ? null : this.cotizacionGenerada.pIdCotizacion,
            peID_VERSION_POL:  this.cotizacionGenerada.pId_Version_Pol == "" ? null : this.cotizacionGenerada.pId_Version_Pol, //Pendiente
            numeromatriculaCat1: this.matricula1 == "" ? '0' : this.matricula1,
            numeromatriculaCat2: this.matricula2 == "" ? '0' : this.matricula2,
            numeromatriculaCat3: this.matricula3 == "" ? '0' : this.matricula3,
            numeromatriculaCat4: this.matricula4 == "" ? '0' : this.matricula4,
            peID_SECUENCIA: "1",
            peSA_AMPARADA_MTE_Id: "769",
            peSA_AMPARADA_MTE_SA: this.sumaMuerte,
            peSA_AMPARADA_GF_Id: "1097",
            peSA_AMPARADA_GF_SA: this.sumaGastos,
            peSA_AMPARADA_PO_Id: "1080",
            peSA_AMPARADA_PO_SA:  this.limitePO == '0' ? '0' : this.sumaMuerte,
            peSA_AMPARADA_PO_Valor: this.limitePO == '0' ? '' : this.sumaPerdidaTipo,
            peSA_AMPARADA_RGM_Id: "877",
            peSA_AMPARADA_RGM_SA: this.sumaRembolso,
            peSA_AMPARADA_RGM_Valor: 'B',
            peDEDUCIBLE: this.deducibleGastos,
            peID_USUARIO: "WEB",
            peId_Rol: localStorage.getItem("idRol"),
            peEsCargaReal: "0",
            pesID_USUARIO_LOGUEADO: localStorage.getItem("userId"),
            datos: {
              pid_empresa: "8",
              pid_cotizacion: this.cotizacionGenerada.pIdCotizacion == undefined ? "0" : this.cotizacionGenerada.pIdCotizacion,//pendiente
              pId_Version_Pol: "1", 
              pf_ini_vigencia: ini_Vigencia,
              pid_producto: this.catProducto.ID_PRODUCTO.toString(),
              pid_version: this.catProducto.ID_VERSION.toString(),
              Pidformapago: this.formaDePago.toString(),
              pid_moneda: this.catMonedas.ID_MONEDA.toString(),
              pId_Agente: localStorage.getItem("userId"),
              pid_usuario: "WEB",
              pid_lin_negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
              pCve_T_Bien: this.catlineas.CVE_T_BIEN,
              PNomp_solicitante: this.colegio,
              pPct_IVA: "16",
              peplazobasico: this.vigencia == "Ciclo Escolar" ? "11" : "12",
              peIdContratante: null,
              peIdDomicilio: null,
              pePCT_COB_RGM: this.sumaRembolsoPorcent,
              peCveTIndemniza: this.limitePO == '0' ? '' : this.sumaPerdidaTipo,
              peCveTRiesgoPer: 'B',
              peDESC_CARACTER: this.listPersonas.toString(),
              peIDCARGA: this.pIdCarga != "" ? this.pIdCarga : "-1",
              peNIVEL_ESCOLAR_A: this.maternal == true ? 'MATERNAL' : null,
              peNIVEL_ESCOLAR_B: this.kinder == true ? 'KINDER' : null,
              peNIVEL_ESCOLAR_C: this.primaria == true ? 'PRIMARIA' : null ,
              peNIVEL_ESCOLAR_D: this.secundaria == true ? 'SECUNDARIA' : null,
              peNIVEL_ESCOLAR_E: this.preparatpria == true ? 'PREPARATORIA' : null,
              peNIVEL_ESCOLAR_F: this.licenciatura == true ? 'LICENCIATURA' : null,
              peDESC_COLEGIO: this.colegio,
              peH_MATUTINO_D: this.matutinoDe == "" ? null : this.matutinoDe,
              peH_MATUTINO_H: this.matutinoA == "" ? null : this.matutinoA,
              peH_VESPERTINO_D: this.vespertinoDe == "" ? null : this.vespertinoDe,
              peH_VESPERTINO_H: this.vespertinoA == "" ? null : this.vespertinoA,
              pCiclo_Escolar: this.vigencia,
              PeID_Usuario: "WEB",
              pcve_sist_admon: this.sistemaAdmon =! null ? this.sistemaAdmon : this.infoCotiz.CVE_SIST_ADMON != undefined ? this.infoCotiz.CVE_SIST_ADMON : 'N'
            }
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const guardar = this.$store.getters.getRespuestaREST;
          this.modal.cotizarGuardar = true
          this.numCotizacion = guardar.pNum_Cotizacion
          this.pIdCarga = guardar.peIDCARGA
          this.cotizacionGenerada = guardar;
          this.actualizar = true;
          this.primaNeta = guardar.pImp_Prima_neta
          this.pagoFR = guardar.pImp_Rcgos_PagoFR
          this.derechos = guardar.pImp_Derechos;
          this.iva = guardar.pImp_Iva;
          this.primaTotal = guardar.pImp_Prima_Total;
          this.redirect = "nueva"
          this.arrCotiz = guardar;
          localStorage.setItem('idCot', guardar.pIdCotizacion)
          // this.obtenerAgente();
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage
          let errortemp = error.split(' ')
          if( errortemp[1] + errortemp[2] == 'fechainicio'){
              this.isInvalid.inicioV = true;
          }
          this.$swal({
              icon: 'error',
              title: 'Error',
              text: error,
            });
        }
        
      } catch (error) {
        console.log(error);
        this.$swal({
              icon: 'error',
              title: 'Error',
              text: "Error al guardar la cotización.",
            });
      }
    },
    async getPDF(){
      this.modal.verDoc = true;
      const payload = {
        metodo: "GETPDFAPE",
        data: {
          // pID_COTIZACION: "1452563",
          pID_COTIZACION: this.cotizacionGenerada.pIdCotizacion,
          // pNUM_COTIZACION: "2452563",
          pNUM_COTIZACION: this.numCotizacion,
          // PID_VERSION_POL: "1",
          PID_VERSION_POL: this.cotizacionGenerada.pId_Version_Pol,
          pID_PRODUCTO: this.catProducto.ID_PRODUCTO.toString(),
          pID_VERSION:  "1",
          // pID_VERSION:  this.catProducto.ID_VERSION.toString(),
          pID_MONEDA: this.catMonedas.ID_MONEDA.toString(),
          pID_COND_COBRO: "15",
          pID_LIN_NEGOCIO: this.catlineas.ID_LIN_NEGOCIO.toString(),
          pIdUsuarioLogueado: localStorage.getItem("userId"),
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const base64 = this.$store.getters.getRespuestaREST;
          this.b64 ='data:application/pdf;base64,' + base64;
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    async actualizaCotiz(){
      const prom = new Promise( (resolve) => {
        this.$store.commit('showLoading')
        resolve(
          this.buscaCotiz(),
          this.catSumaAsegurada(),
          this.sumasAseguradasFactor(),
          this.$store.commit('hideLoading')
          )
        })
        prom.then( () => {
          if(this.sumaMuerte == "0") { this.sumaMuerte = this.sumaPerdida}
          if(this.sumaMuerte == '0') { this.sumaMuerte  = this.sumaGastos}
          const promise = new Promise( (resolve) => {
            resolve(
              // this.saamLimitePO(),
              this.sumasAseguradasFactor(),
              this.sumasAseguradasLimite('edicion'),
              this.obtenerAgente('edicion'),
              this.getObjetos()
              )
            })
            promise.then( () => {
              this.deducible()
              if(this.limitePO == '0') { this.sumaMuerte  = this.sumaGastos}
            })

        })
    },
    //Actualiza cotizacion
    async buscaCotiz(){
      this.condiciones = false
      const payload = {
        metodo: "BURCARCOTIZACIONAPE",
        data: {
          // PEID_COTIZACION: "1452563",
          PEID_COTIZACION: this.routeCot,
          // PEID_VERSION_POL: "1",
          PEID_VERSION_POL: this.routeVersion,
          PEID_LINEA_NEGOCIO: this.catlineas.ID_LIN_NEGOCIO.toString(),
          pIdUsuarioLogueado: localStorage.getItem("userId"),
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const agente = this.$store.getters.getRespuestaREST;
          this.infoCotiz = agente
          if(localStorage.getItem("idRol") != '20159'){
            if(agente.B_CE === 'V') {
              this.disabledAll = true
            }
          }
          localStorage.setItem('idCot', agente.ID_COTIZACION)
          this.cotizar = true;
          this.actualizar = true;
          this.redirect = "edicion"
          let vigengia = agente.F_INI_VIGENCIA[6] + agente.F_INI_VIGENCIA[7] + agente.F_INI_VIGENCIA[8] + agente.F_INI_VIGENCIA[9] 
          + "-" + agente.F_INI_VIGENCIA[3] + agente.F_INI_VIGENCIA[4] + "-" + agente.F_INI_VIGENCIA[0] + agente.F_INI_VIGENCIA[1]
          this.fechaCotizacion = agente.FH_CREACION
          this.numCotizacion = agente.NUM_COTIZACION
          this.formaDePago = agente.ID_FORMA_PAGO
          this.vigencia = agente.CICLO_ESCOLAR
          
          this.deducibleGastos = agente.IMP_DEDUCIBLE
          setTimeout(() => { this.sumaPerdidaTipo =  this.limitePO == '0' ? '' : agente.CVE_T_INDEMNIZA }, 2000);
          this.sumaRembolsoPorcent = agente.PCT_COB_RGM
          this.cotizacionGenerada.pImp_Rcgos_PagoFR = agente.IMP_RCGOS_PAGOFR
          this.cotizacionGenerada.pImp_Derechos = agente.IMP_DERECHOS
          this.cotizacionGenerada.pImp_Iva = agente.IMP_IVA
          this.cotizacionGenerada.pImp_Prima_neta = agente.IMP_PRIMA_NETA
          this.cotizacionGenerada.pImp_Prima_Total = agente.IMP_PRIMA_TOTAL
          
          
          
          this.inicioVigencia = vigengia
          this.finVigenciaInput = agente.F_FIN_VIGENCIA
          this.colegio = agente.DESC_COLEGIO 
          agente.NIVEL_ESCOLAR_A == 'MATERNAL' ? this.maternal = true : null
          agente.NIVEL_ESCOLAR_B == 'KINDER' ? this.kinder = true : null
          agente.NIVEL_ESCOLAR_C == 'PRIMARIA' ? this.primaria = true : null
          agente.NIVEL_ESCOLAR_D == 'SECUNDARIA' ? this.secundaria = true : null
          agente.NIVEL_ESCOLAR_E == 'PREPARATORIA' ? this.preparatpria = true : null
          agente.NIVEL_ESCOLAR_F == 'LICENCIATURA' ? this.licenciatura = true : null
          for (let i = 0; i < agente.DESC_CARACTER_Arreglo.length; i++) {
            if(agente.DESC_CARACTER_Arreglo[i] == "ALUMNOS") {this.listPersonas[0] = agente.DESC_CARACTER_Arreglo[i]}
            if(agente.DESC_CARACTER_Arreglo[i] == "PERSONAL DOCENTE") {this.listPersonas[1] = agente.DESC_CARACTER_Arreglo[i]}
            if(agente.DESC_CARACTER_Arreglo[i] == "PERSONAL ADMINISTRATIVO") {this.listPersonas[2] = agente.DESC_CARACTER_Arreglo[i]}
            
          }
          this.matutinoDe = agente.H_MATUTINO_D
          this.matutinoA = agente.H_MATUTINO_H
          this.vespertinoDe = agente.H_VESPERTINO_D
          this.vespertinoA = agente.H_VESPERTINO_H
          for (let i = 0; i < agente.CATEGORIAS.length; i++) {
            if(agente.CATEGORIAS[i].peID_CATEGORIA == "1"){
              this.matricula1 = agente.CATEGORIAS[i].peNUM_MATRICULA
            }
            if(agente.CATEGORIAS[i].peID_CATEGORIA == "2"){
              this.matricula2 = agente.CATEGORIAS[i].peNUM_MATRICULA
            }
            if(agente.CATEGORIAS[i].peID_CATEGORIA == "3"){
              this.matricula3 = agente.CATEGORIAS[i].peNUM_MATRICULA
            }
            if(agente.CATEGORIAS[i].peID_CATEGORIA == "4"){
              this.matricula4 = agente.CATEGORIAS[i].peNUM_MATRICULA
            }
          }
          this.primaNeta = agente.IMP_PRIMA_NETA;;
          this.pagoFR = agente.IMP_RCGOS_PAGOFR;
          this.derechos = agente.IMP_DERECHOS;
          this.iva = agente.IMP_IVA;
          this.primaTotal = agente.IMP_PRIMA_TOTAL;
          this.idClienteUnico = agente.ID_CLIENTE_UNICO
          this.sistemaAdmon = agente.CVE_SIST_ADMON

          agente.COBERTURAS.map( cob => {
            //Suma Muerte Accidental
            if (cob.ID_COBERTURA == 769) { 
              this.sumaMuerte = cob.SA_AMPARADA_FORMATEADA 
            } 
            //Suma gastos Funerarios
            if (cob.ID_COBERTURA == 1097) { this.sumaGastos = cob.SA_AMPARADA_FORMATEADA } 
            //Suma Perdidas Organicas
            if (cob.ID_COBERTURA == 1080) { 
              this.sumaPerdida = cob.SA_AMPARADA_FORMATEADA
              if(this.sumaPerdida == "0") { this.sumaPerdida = this.sumaMuerte}
            }
            //Suma Reembolso Gastos Medicos
            if (cob.ID_COBERTURA == 877) { this.sumaRembolso = cob.SA_AMPARADA_FORMATEADA } 
            
          })
          
          
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage
          this.$swal({
              icon: 'error',
              title: 'Error',
              text: error,
            });
        }
        
      } catch (error) {
        console.log(error);
      }
      
    },
    async sendEmail(){
      const payload = {
        metodo: "SENDEMAILAPE",
        data: {
          // pID_COTIZACION: "1452563",
          pID_COTIZACION: this.cotizacionGenerada.pIdCotizacion,
          // pNUM_COTIZACION: "2452563",
          pNUM_COTIZACION: this.numCotizacion,
          // PID_VERSION_POL: "1",
          PID_VERSION_POL: this.cotizacionGenerada.pId_Version_Pol,
          pID_PRODUCTO: this.catProducto.ID_PRODUCTO.toString(),
          // pID_VERSION:  "1",
          pID_VERSION:  this.catProducto.ID_VERSION.toString(),
          pID_MONEDA: this.catMonedas.ID_MONEDA.toString(),
          pID_COND_COBRO: "15",
          pID_LIN_NEGOCIO: this.catlineas.ID_LIN_NEGOCIO.toString(),
          pIdUsuarioLogueado: localStorage.getItem("userId"),
          pCorreo: this.emailModal
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const email = this.$store.getters.getRespuestaREST;
          this.modalExito('¡Cotización enviada con éxito!', 'Si deseas consultarla después puedes hacerlo en la sección de Cotizaciones y Pólizas.')
          this.msjEmail = email
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    emitir(){
      let monto = this.primaTotal.split(",")
      window.location.href =`https://servicios.latinoseguros.com.mx/ClienteUnico/Acceso/Acceso.aspx?id=${localStorage.getItem("idRol") === '20154' ? localStorage.getItem("userId") : '10888'}&idApp=10077`;
    },
    redirCondicionesEspe(){
      if(this.redirect == "nueva") {
        window.location.href = `/#/cotizador/escuelas/condiciones?id=${this.arrCotiz.pIdCotizacion}&version=${this.arrCotiz.pId_Version_Pol}&num=${this.numCotizacion}`;
      } 
      else if(this.redirect == "edicion") {
        window.location.href = `/#/cotizador/escuelas/condiciones?id=${this.infoCotiz.ID_COTIZACION}&version=${this.infoCotiz.ID_VERSION_POL}&num=${this.infoCotiz.NUM_COTIZACION}`;
      }
    },
    async obtenerAgente(type){
        const payload = {
          metodo: "GET_AGENTE",
          data: {
            ClaveAgente: localStorage.getItem("idRol") != '20154' ? type === 'nueva' ? '10888' : this.infoCotiz.ID_AGENTE : localStorage.getItem("userId")
          },
        };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const agente = this.$store.getters.getRespuestaREST;
          this.agenteGeneral = agente.psNombre_Agente
          this.claveAgenteGeneral = agente.psClave_Agente
          var campo = document.getElementById('agente');
          // campo.style.color="rgba(3, 0, 184, 0.507)";
          // campo.style
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    async numAsegurados(){
      const payload = {
        metodo: "NUMASEGURADOSAPE",
        data: {
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pid_lin_negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
          pIdUsuarioLogueado: localStorage.getItem("userId")
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const numero = await this.$store.getters.getRespuestaREST;
          this.numeroAsegurados = numero[0].NUM_MIN_UNIDSRGO;
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    async sumasAseguradasFactor(){
      this.habilitaInicio()
      if(this.inicioVigencia != 'Invalid date'){
        this.finVigenciaM()
      }
      this.catSumaAsegurada();
      const payload = {
        metodo: "SAAMPARADAFACTORAPE",
        data: {
          pId_Moneda: this.catMonedas.ID_MONEDA.toString(),
          pePlazoBasico: this.vigencia == "Ciclo Escolar" ? "10" : "12",
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pid_lin_negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
          peIdAgente: localStorage.getItem("userId"),
          peId_Rol: localStorage.getItem("idRol"),
          peB_CE: this.infoCotiz.B_CE
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const coberturas = await this.$store.getters.getRespuestaREST;
          if (this.infoCotiz.B_CE == 'V') {
            console.log('entra sumasAseguradasFactor');
          } else {
            this.sumaAseg = coberturas.Table1;
          }
          this.factor = coberturas.Table2[0].Id_Tb_Factor
          
          
          setTimeout( () => {
           this.catalogoPorcentajesRGM()
           this.finVigenciaM()
           this.catIndemniza()
          }, 1000)
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(inputDate) {
      const parts = inputDate.split('/');
      const day = parts[0];
      const month = parts[1];
      const year = parts[2];
      
      return `${year}-${month}-${day}`;
    },
    async habilitaInicio(){
      this.calculaInicio = false
      const payload = {
        metodo: "HABILITAINICIOAPE",
        data: {
          pFechaInicio: "-1",
          pVigenciaTexto: this.vigencia,
          pUsuarioRegistro: localStorage.getItem("userId"),
          peId_Rol: localStorage.getItem("idRol")
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const data = await this.$store.getters.getRespuestaREST;
          if (data != "") {
            this.inicioVigencia = this.formatDate(data.fechaInicio)
            this.calculaInicio = data.disabled
            this.finVigenciaM()
          }
          console.log(data);
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    async sumasAseguradasLimite(){ 
      const payload = {
        metodo: "SAAMPARADALIMITEAPE",
        data: {
          pId_Moneda: this.catMonedas.ID_MONEDA.toString(),
          pePlazoBasico: this.vigencia == "Ciclo Escolar" ? "10" : "12",
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pid_lin_negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
          peIdAgente: localStorage.getItem("userId"),
          Id_Tb_Factor: this.factor,
          peB_CE: this.infoCotiz.B_CE,
          pSAMinima: this.sumaMuerte.split(",").join('')
        },
      };
      // let suma = this.sumaMuerte.split(",").join('')
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const limite = await this.$store.getters.getRespuestaREST;
          if (this.infoCotiz.B_CE == 'V') {
            console.log('entra 2');
          } else {

            this.sumaGastos = limite[0].SA_ASEGURADA
          }
          this.deducible()
        }
        
      } catch (error) {
        console.log(error);
      }
      if(this.sumaRembolsoPorcent != ''){
        this.porcentajeRembolso()
      }
      this.saamLimitePO()
    },
    async porcentajeRembolso(){
      const payload = {
        metodo: "PORCENTAJEREMBOLSOAPE",
        data: {
          pId_Moneda: this.catMonedas.ID_MONEDA.toString(),
          pePlazoBasico: this.vigencia == "Ciclo Escolar" ? "10" : "12",
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pid_lin_negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
          peIdAgente: localStorage.getItem("userId"),
          pSAMinima: this.sumaMuerte.split(",").join(''),
          pePctSARGM: this.sumaRembolsoPorcent
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const sumaRembolso = await this.$store.getters.getRespuestaREST;
          this.sumaRembolso = sumaRembolso[0].SA_ASEGURADAConFormato
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    async fechasVigencia(){
      const payload = {
        metodo: "FECHAVIGENCIAAPE",
        data: {
          pFechaInicio: "-1",
          pVigenciaTexto: "-1",
          pUsuarioRegistro: localStorage.getItem("userId"),
          peId_Rol: localStorage.getItem("idRol")
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const vigencia = this.$store.getters.getRespuestaREST;
          this.arrVigencia = vigencia[0]
          // if(this.arrVigencia[0] === this.arrVigencia[1]){
          //   this.inicioVigencia = this.arrVigencia[0];
          //   // this.finVigenciaM()
          // }
          

        }
        
      } catch (error) {
        console.log(error);
      }
    },
    async saamLimitePO(type){
      const payload = {
        metodo: "SAAMLIMITEPOAPE",
        data: {
          pId_Moneda: this.catMonedas.ID_MONEDA.toString(),
          pePlazoBasico: this.vigencia == "Ciclo Escolar" ? "10" : "12",
          pId_Producto: this.catProducto.ID_PRODUCTO.toString(),
          pId_Version: this.catProducto.ID_VERSION.toString(),
          pid_lin_negocio: this.catlineas.ID_LIN_NEGOCIO.toString(),
          peIdAgente: localStorage.getItem("userId"),
          Id_Tb_Factor: this.factor,
          peB_CE: this.infoCotiz.B_CE,
          pSAMinima: this.sumaMuerte.split(",").join('')
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const limitePO = this.$store.getters.getRespuestaREST;
          this.limitePO = limitePO[0].SA_ASEGURADA
          if(this.limitePO == '0') {
            this.PO_Disabled = true; 
            
            this.sumaPerdida = 'Suma asegurada';
          } else {
            this.sumaPerdida = this.sumaMuerte;
          }
          if(type = 'edicion'){
            if (this.limitePO == '0') {
                this.sumaMuerte = this.sumaGastos
                // this.sumaPerdidaTipo = 'Escala'
            }
          }
          // this.sumaPerdida = limitePO[0].SA_ASEGURADA
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage 
          this.sumaPerdida = this.sumaMuerte;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async created(){
    this.routeCot = this.$route.query.cot
    this.routeVersion = this.$route.query.version
    this.cotizacionGenerada.pIdCotizacion = this.routeCot
    this.cotizacionGenerada.pId_Version_Pol = this.routeVersion

    await this.catalogoProductos();
    await this.catalogoLineas();
    await this.catalogoMoneda();
    await this.catalogoFormaPago();
    await this.catalogoVigencia();
    await this.catalogoCoberturas();

    if(this.routeCot != undefined){
      this.actualizaCotiz()
    } else{
      this.alumnos = true;
      this.listPersonas[0] = "ALUMNOS"
      this.obtenerAgente('nueva')
    }
    
    this.numAsegurados()
    this.fechasVigencia()
    setTimeout(() => { this.getObjetos() }, 1000);

    
  },
  
};
</script>
<style>

/* Estilo básico para el input de tipo time */

/* Cambiar el tamaño del texto */
input[type="time"] {
  font-size: 12px;
}

/* Cambiar el ancho del input */
input[type="time"] {
  width: 118
  px;
}

/* Cambiar la altura del input */
input[type="time"] {
  height: 40px;
}

/* [type="time"] {
  background:transparent url(/assets/images/clock.png)  97% 50% no-repeat !important;
}
[type="time"]::-webkit-inner-spin-button {
  display: none;
}
[type="time"]::-webkit-calendar-picker-indicator {
  opacity: 0;
} */

.montos{
  float: right;
}
.inputInicial{
  color: rgba(25, 36, 134, 0.863);
  font-weight: bold !important;
  font-family: 'Lucida Casual', 'Comic Sans MS';
}
.invalid-Feedback{
  color: red;
}
.header-modal{
  background-color: black;
}
.btn-modal{
  background-color: black;
  color: white;
  border-color: black;
}
.x-large-textarea{
  height: 30em;
  width: 700px;
}
.border{
  border-radius: 15px;
  font-weight: bold;

}
.modal{
  border-radius: 50px;
}
.totales{
  font-size: small; 
  color: deepskyblue; 
  font-weight: bold;
}
.inputCyC{
  width: 110px;
  align-content: center;
}
.title{
  color: rgb(45, 54, 139);
  font-weight: bold;
}
.title2{
  color: #00b2e3;
  font-weight: bold;
}
.card{
  border-radius: 30px;
}
.round {
  position: relative;
}

.round .label-checkbox {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 28px;
  left: 0;
  position: absolute;
  top: 0;
  width: 28px;
}

.round .label-checkbox:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 7px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}
.round input[type="checkbox"]:checked + .label-checkbox {
  background-color: #66bb6a;
  border-color: #66bb6a;
}

.round input[type="checkbox"]:checked + .label-checkbox:after {
  opacity: 1;
}


.round .label-radio{
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 28px;
  left: 0;
  position: absolute;
  top: 0;
  width: 28px;
}

.round .label-radio:after{
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 7px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}
.round input[type="radio"]:checked + .label-radio {
  background-color: #66bb6a;
  border-color: #66bb6a;
}
.radio-margin{
  padding: 1px !important;
  margin-top: 5px !important;;
}
.round input[type="radio"]:checked + .label-radio:after{
  opacity: 1;
}

.btn-file {
  position: relative;
  overflow: hidden;
}
.btn-file input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: white;
  cursor: inherit;
  display: block;
}
</style>